import React from "react";
import { useQuery } from "@tanstack/react-query";
import api, { fmtDate } from "../lib/api";
import { CartellaVisite } from "./CartellaVisite";
import { ymd } from "./VisiteDialogs";
import { Tiles } from "./SmartUI";

export default function VisiteSmart({ o }) {
  const oggi = ymd(new Date());
  const { data: list = [] } = useQuery({ queryKey: ["vm-ospite", o.id], queryFn: async () => (await api.get("/visite-mediche", { params: { ospite_id: o.id } })).data, refetchInterval: 30000 });
  const fatte = list.filter((v) => v.stato === "fatta" && v.data <= oggi).sort((a, b) => (b.data + (b.ora || "")).localeCompare(a.data + (a.ora || "")));
  const prog = list.filter((v) => v.stato === "programmata" && v.data >= oggi).sort((a, b) => (a.data + (a.ora || "")).localeCompare(b.data + (b.ora || "")));
  const d30 = ymd(new Date(Date.now() - 29 * 864e5));
  const attesa = list.filter((v) => v.ricetta_attesa || v.ricetta_attesa_bisogno).length;
  const [u, p] = [fatte[0], prog[0]];
  return (
    <div className="space-y-4" data-testid="scheda-visite">
      <Tiles testid="visite-tiles" items={[
        ["Ultima visita", u ? fmtDate(u.data).slice(0, 5) : "—", u ? `${u.tipo_visita || ""}${u.medico ? ` · ${u.medico}` : ""}` : "nessuna", "#0d9488"],
        ["Prossima visita", p ? fmtDate(p.data).slice(0, 5) : "—", p ? `${p.ora || ""} ${p.tipo_visita || ""}`.trim() : "nessuna in programma", "#0284c7"],
        ["Ultimi 30 giorni", fatte.filter((v) => v.data >= d30).length, "visite fatte", "#0d9488"],
        ["Ricette da caricare", attesa, attesa ? "da allegare alla visita" : "nessuna", "#b45309", attesa > 0],
      ]} />
      <div className="rounded-xl border bg-white p-3 sm:p-4"><CartellaVisite ospite={{ ...o, ospite_id: o.id }} giorno={oggi} /></div>
    </div>
  );
}
